export const videoData = [
  {
    title:
      'Chillar App se Paise kaise Kamaye II Chillar app unlimited Trick II Loot Parivar',
    name: 'Loot Parivar',
    channelLink: 'https://www.youtube.com/c/LootParivar',
    date: '12/1/2022',
    link: 'https://www.youtube.com/watch?v=bGtq6HIC_oY'
  },
  // {
  //   title:
  //     'रोजाना 500/1000 रुपए मोबाइल से कमाए सिर्फ 10 मिनट मे best earning app without investment',
  //   name: 'Raksha ki Rasoi Tech',
  //   channelLink: 'https://www.youtube.com/c/RakshakiRasoiTech',
  //   date: '12/2/2022',
  //   link: 'https://www.youtube.com/watch?v=qBxTi9UmLh0'
  // },
  // {
  //   title:
  //     '2022 BEST SELF EARNING APP | EARN DAILY FREE UPI CASH WITHOUT INVESTMENT || NEW EARNING APP TODAY',
  //   name: 'Tech tube daddy',
  //   channelLink: 'https://www.youtube.com/channel/UCnPCKScptnS2ehXT-NVJmLQ',
  //   date: '12/5/2022',
  //   link: 'https://www.youtube.com/watch?v=FJs-ejQ8Z6g&t=177s'
  // },
  // {
  //   title:
  //     'Students కోసం Daily ఈ Simple Task చేసి రోజు ₹ 250/- Earnings | New Money Earning App Telugu 2022',
  //   name: 'Tek Shekar',
  //   channelLink: 'https://www.youtube.com/@tekshekar9460',
  //   date: '12/7/2022',
  //   link: 'https://www.youtube.com/watch?v=1QmC5FlWqoQ'
  // },
  // {
  //   title:
  //     '10 GAMES : ₹5000 New Earning Apps 2022 | Best UPI Cash Earning Apps 2022 | ₹500 Free UPI Cash',
  //   name: 'Recharge offers',
  //   channelLink: 'https://www.youtube.com/@RechargeOffersYT',
  //   date: '12/7/2022',
  //   link: 'https://www.youtube.com/watch?v=JZZ5NXY4TdI'
  // },
  // {
  //   title:
  //     'Earn daily ₹30 - ₹50 | Only 5 min Work | My payment Proof | Part time job for students',
  //   name: 'oiii selfie',
  //   channelLink: 'https://www.youtube.com/@oiiiSelfiee',
  //   date: '12/8/2022',
  //   link: 'https://www.youtube.com/watch?v=s_j5xAnXmo8&t=2s'
  // },
  // {
  //   title:
  //     'മൊബൈലിൽ 10 Minute Work ചെയ്ത് അപ്പോൾ തന്നെ Googlepayൽ Withdraw ചെയ്യുന്നത് കാണാം UPI/Phonepay',
  //   name: 'Ammus Talks',
  //   channelLink: 'https://www.youtube.com/channel/UC1FPyeZ89u5NXo9bCid2TcQ',
  //   date: '12/9/2022',
  //   link: 'https://youtu.be/rJclUbt4oGQ'
  // },
  // {
  //   title: 'FREE FIRE MAX UNLIMITED REDEEM CODE TRICK😲 || GET FREE DIAMONDS💎',
  //   name: 'SWAM',
  //   channelLink: 'https://www.youtube.com/watch?v=YVTsHCObDbc',
  //   date: '12/13/2022',
  //   link: 'https://www.youtube.com/watch?v=YVTsHCObDbc'
  // },
  // {
  //   title:
  //     '🛑 എനിക്ക് 3000 രൂപ Gpay കിട്ടി ✅ | Best earning application in 2022 | UPI, Gpay, phonepe |new',
  //   name: 'Campuz trendz',
  //   channelLink: 'https://www.youtube.com/c/CampusTrendz/about',
  //   date: '12/14/2022',
  //   link: 'https://www.youtube.com/watch?v=KZknVK1rbVU&t=218s'
  // },
  // {
  //   title:
  //     'NEW EARNING APP TODAY | ₹72 FREE UPI CASH EARNING APPS 2022 | WITHOUT INVESTMENT BEST EARNING APP',
  //   name: 'technical Dwivedi ji',
  //   channelLink: 'https://www.youtube.com/channel/UC4-b9VKg-JAKDfp8vlDqVSA',
  //   date: '12/18/2022',
  //   link: 'https://www.youtube.com/watch?v=mxqQjkBzRVk'
  // },
  // {
  //   title:
  //     'ডাউনলোড করলেই টাকা 🤑 Earn Money Online Without Investment 💸 Best Part Time job | Work From Home 💰',
  //   name: 'TIYASHX',
  //   channelLink: 'https://www.youtube.com/@TechnicalTiyashx',
  //   date: '12/19/2022',
  //   link: 'https://www.youtube.com/watch?v=7PKIV0xD78k'
  // },
  // {
  //   title:
  //     'Daily Earning App 🔴 Live Withdrawl | No Investment | Age 16+ | Anybody can Apply!!',
  //   name: 'Grace with me',
  //   channelLink: 'https://www.youtube.com/channel/UCa0KkdhwCBKl1nAt6316D2w',
  //   date: '12/20/2022',
  //   link: 'https://youtu.be/TdwrdwCxRV4'
  // },
  // {
  //   title:
  //     'NEW EARNING APP TODAY |₹1000 FREE UPI CASH EARNING APPS 2022 | WITHOUT INVESTMENT TOP5 EARNINGAPPS',
  //   name: 'Dtech Guptaji',
  //   channelLink: 'https://m.youtube.com/c/DtechGuptajii',
  //   date: '12/21/2022',
  //   link: 'https://youtu.be/LfpvsK7yNDA'
  // },
  // {
  //   title:
  //     'Best Money Earning App 2023 ।। Earn Daily ₹30 UPI Cash Without Investment ।। Rupiyo Money App KKV',
  //   name: 'Kunal k videos',
  //   channelLink: 'https://www.youtube.com/@KunalKVideos/videos',
  //   date: '12/22/2022',
  //   link: 'https://youtu.be/ZeKCabPH-ls'
  // },
  // {
  //   title:
  //     '🔴 EARN DAILY 🔥 Rs 900 | No Investment Job | Gpay , Phonepe | With Proof | Frozenreel l',
  //   name: 'Frozen reel',
  //   channelLink: 'https://www.youtube.com/c/FrozenReel/videos',
  //   date: '12/23/2022',
  //   link: 'https://www.youtube.com/watch?v=e2650wjMMQM&t=1s'
  // },
  // {
  //   title:
  //     '💥 Best Money Earning App Telugu | For Students | Easy Way To Earn Money Online Telugu',
  //   name: 'Money Cool',
  //   channelLink: 'https://youtube.com/@ShivamMallelwar',
  //   date: '12/26/2022',
  //   link: 'https://youtu.be/d2C5uomFdpk'
  // },

  // {
  //   title:
  //     'इस APP से रोज़ कमाओ ₹1000-2000 | NO Investment | With Proof | Sikka Earning App 2023 🔥',
  //   name: 'Manoj dey',
  //   channelLink: 'https://www.youtube.com/c/manojdey',
  //   date: '1/1/2023',
  //   link: 'https://youtu.be/aJAqY9qcJbA'
  // },
  // {
  //   title:
  //     'Sikka App se Paise Kaise kamaye | Earn 200 ₹ Daily | Best self Earning App | online Earning App',
  //   name: 'Akash Raxar',
  //   channelLink: 'https://m.youtube.com/channel/UCNvwFGJwQDTXctLwfL-Ydmw',
  //   date: '1/7/2023',
  //   link: 'https://youtu.be/iYse9ZJm_KE'
  // },
  // {
  //   title:
  //     'Earn daily ₹30 - ₹50 | Only 5 min Work | My payment Proof | Part time job for students',
  //   name: 'Oiii Selfiee',
  //   channelLink: 'https://www.youtube.com/@oiiiSelfiee',
  //   date: '1/5/2023',
  //   link: 'https://www.youtube.com/watch?v=GFgpUwi11DU&t=365s'
  // },
  // {
  //   title:
  //     '😍 Best Play Store Earning App | Earn Daily 5000 Without Investment',
  //   name: 'GKafroz',
  //   channelLink: 'https://www.youtube.com/channel/UCFqTfpH5x5QLXtfA6Hr7UYw',
  //   date: '1/14/2023',
  //   link: 'https://youtu.be/Olpu4c2j7Bw'
  // },
  // {
  //   title:
  //     'Live  Earning App/-| Chillar App| Work from Home Jobs| Typing Work|Data Entry Work| Hindi',
  //   name: 'Job Seekers',
  //   channelLink: 'https://www.youtube.com/@JobSeekers1',
  //   date: '1/14/2023',
  //   link: 'https://www.youtube.com/watch?v=0OLy2CltUeA'
  // },
  // {
  //   title:
  //     '🔴 10 MB : ₹5000 NEW EARNING APPS 2023 | BEST UPI CASH EARNING APPS 2023 | ₹500 FREE UPI CASH',
  //   name: 'Recharge Offers',
  //   channelLink: 'https://www.youtube.com/@RechargeOffersYT',
  //   date: '1/15/2023',
  //   link: 'https://youtu.be/t6Rw5qcjg3Y'
  // },
  // {
  //   title:
  //     '2023 Best Money Earning App ।। Paisa Kamane Wala App ।। Earn ₹30 Free Daily in UPI ।। Task Deal App',
  //   name: 'Kunal K videos',
  //   channelLink: 'https://m.youtube.com/c/KunalKVideos',
  //   date: '1/20/2023',
  //   link: 'https://youtu.be/Ns7NHPaGOgY'
  // },
  // {
  //   title:
  //     'Earn 100₹ Daily Doing Tasks | How to Earn Money Online 2023 | Telugu',
  //   name: 'Srikanth world',
  //   channelLink: 'https://www.youtube.com/@srikanthworld',
  //   date: '1/27/2023',
  //   link: 'https://www.youtube.com/watch?v=NZYAJH4x-rA&t=89s'
  // },
  {
    title:
      'Claim Today Redeem Code Fast🔥🤩| Only 2 Hours Left| Free Fire Tamil|',
    name: 'Mass mani',
    channelLink: 'https://www.youtube.com/channel/UCaDydun80aBvfZgQtiYqdtg',
    date: '1/30/2023',
    link: 'https://youtu.be/J2_Vpx9lRNg'
  }
];
